import { Temporal } from "js-joda";

import { validationMessages } from "infrastructure/localization";
import { createValidatable, createValidationIssue } from "infrastructure/validation";
import { ITenant, IAccount } from "ui/screens/security/models";
import { isPlexTenant } from "ui/screens/security/shared/helpers";
import { IPickerState } from "ui/screens/security/shared/picker/Picker.types";

import { IGrantRoleFormState, tenantPickerName, accountPickerName, validDateFromPickerName, validDateToPickerName, enterpriseWideFieldName } from "./GrantRole.state";

export const dateRangeRequired = (account?: IAccount, tenant?: ITenant) => {
  return account?.isPlex || (!!tenant && isPlexTenant(tenant?.tenantId));
};

export const getGrantRoleFormState = (): IGrantRoleFormState => {
  return {
    [tenantPickerName]: createValidatable<IPickerState<ITenant>>(
      {
        selectedItems: []
      },
      [
        {
          valid: (validatedValue: IPickerState<ITenant>) => {
            return validatedValue.selectedItems.length > 0;
          },
          result: createValidationIssue({ messageId: validationMessages.error("requiredField") })
        }
      ]
    ),
    [accountPickerName]: createValidatable<IPickerState<IAccount>>(
      {
        selectedItems: []
      },
      [
        {
          valid: (validatedValue: IPickerState<IAccount>) => {
            return validatedValue.selectedItems.length > 0;
          },
          result: createValidationIssue({ messageId: validationMessages.error("requiredField") })
        }
      ]
    ),
    [validDateFromPickerName]: createValidatable<Temporal | undefined>(
      undefined,
      [
        {
          valid: (validatableValue: Temporal | undefined, other?: any[]) => {
            const account = (other?.[1] as IPickerState<IAccount>).selectedItems[0];
            const tenant = (other?.[2] as IPickerState<ITenant>).selectedItems[0];

            if (dateRangeRequired(account, tenant)) {
              return validatableValue != null;
            } else {
              return true;
            }
          },
          result: createValidationIssue({ messageId: validationMessages.error("requiredField") })
        },
        {
          valid: (validatableValue: Temporal | undefined, other?: any[]) => {
            const validateToDateValue = other?.[0];

            if (validatableValue && validateToDateValue) {
              return validatableValue < validateToDateValue;
            } else {
              return true;
            }
          },
          result: createValidationIssue(undefined)
        }
      ],
      validatable => {
        validatable.validation.dependsOnFieldNames = [validDateToPickerName, accountPickerName, tenantPickerName];
      }
    ),
    [validDateToPickerName]: createValidatable<Temporal | undefined>(
      undefined,
      [
        {
          valid: (validatableValue: Temporal | undefined, other?: any[]) => {
            const account = (other?.[1] as IPickerState<IAccount>).selectedItems[0];
            const tenant = (other?.[2] as IPickerState<ITenant>).selectedItems[0];

            if (dateRangeRequired(account, tenant)) {
              return validatableValue != null;
            } else {
              return true;
            }
          },
          result: createValidationIssue({ messageId: validationMessages.error("requiredField") })
        },
        {
          valid: (validatableValue: Temporal | undefined, other?: any[]) => {
            const validateFromDateValue = other?.[0];
            if (validatableValue && validateFromDateValue) {
              return validatableValue > validateFromDateValue;
            } else {
              return true;
            }
          },
          result: createValidationIssue({ messageId: validationMessages.error("dateRange") })
        }
      ],
      validatable => {
        validatable.validation.dependsOnFieldNames = [validDateFromPickerName, accountPickerName, tenantPickerName];
      }
    ),
    [enterpriseWideFieldName]: createValidatable<boolean | undefined>(undefined, [])
  };
};
